// extracted by mini-css-extract-plugin
export default {"content":"style_content__i2b9x","withRightPanel":"style_withRightPanel__oUiNZ","fullPageContent":"style_fullPageContent__rhMYU","loading":"style_loading__Gqbwd"};